import styles from './index.module.css';

export const Column = ({ children, gap = 0, className, style, ...props }) => {
    return (
        <div
            {...props}
            className={[styles.column, className].join(' ')}
            style={{ gap: `${gap * 4}px`, ...style }}
        >
            {children}
        </div>
    );
};
